var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_48_place_holder",
    "data-name": "Icon/48 place holder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon_48_place_holder_style_",
    "data-name": "Icon/48 place holder (style)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#356ab3",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_payment_light",
    "data-name": "UI icon/payment/light",
    transform: "translate(14 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M17,16H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H17a3,3,0,0,1,3,3V13A3,3,0,0,1,17,16ZM2,6v7a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V6ZM3,2A1,1,0,0,0,2,3V4H18V3a1,1,0,0,0-1-1Z",
    fill: "#33383f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478_Stroke_",
    "data-name": "Vector 478 (Stroke)",
    d: "M0,1A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2H1A1,1,0,0,1,0,1Z",
    transform: "translate(3.999 10)",
    fill: "#33383f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.33cf3e9113c6351091872860a33c8664.svg";
export { ForwardRef as ReactComponent };